import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App as AntApp, ConfigProvider } from "antd";
import { brTheme, useSyncDarkClass } from "@bluerock/corenet/tokens";
import App from "./App";
import { AuthProvider } from "./lib/auth/AuthProvider";
import { useThemeMode } from "./lib/themeMode";

// corenet design tokens: CSS vars + editorial fonts (DM Sans / Source Serif 4 /
// JetBrains Mono). Import BEFORE index.css so local overrides can win.
import "@bluerock/corenet/tokens/colors.css";
import "./index.css";

// Root — a real component (not inline in render()) because the theme mode
// needs a hook: `useThemeMode()` subscribes to the shared store (see
// lib/themeMode.ts) and `useSyncDarkClass` keeps documentElement's `.dark`
// class (which corenet's colors.css — and our own index.css overrides —
// key their dark palette from) in sync with it.
function Root() {
  const mode = useThemeMode();
  useSyncDarkClass(mode);
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, "") || "/"}>
      <AuthProvider>
        <ConfigProvider theme={brTheme(mode === "dark")}>
          {/* Renders a real `<div class="ant-app contents">` — `display:contents`
              keeps it layout-inert, but AntD needs a real host element here to
              apply its base typography reset (font-size/line-height) and scope
              the `.br` cssVar class onto descendants. `component={false}` would
              skip the wrapper and silently break both — same gotcha, same fix,
              as agate's own ThemeProvider (thalia/agate/src/app/theme.tsx). */}
          <AntApp component="div" className="contents">
            <App />
          </AntApp>
        </ConfigProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
